<template>
  <CardModule class="mt-6" :title="$t('registrations.producers.access-plural')">
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="$loja_gerenciar.cadastro.acesso.circus"
          :label="
            $t('registrations.producers.enable-eleven-access-integration')
          "
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="URL ElevenTickets Access"
          :placeholder="$t('registrations.producers.insert-eleven-access-url')"
          v-model="$loja_gerenciar.cadastro.acesso.url_circus"
          type="text"
          :rules="isFill ? [rules.required] : []"
          :error-messages="$loja_gerenciar.cadastro.acesso.error.url_circus"
          :disabled="isDisabled"
        >
        </BaseTextField>
      </v-col>
      <v-col cols="12">
        <BaseTextField
          label="Token ElevenTickets Access"
          :placeholder="
            $t('registrations.producers.insert-eleven-access-token')
          "
          v-model="$loja_gerenciar.cadastro.acesso.token_circus"
          type="text"
          :rules="isFill ? [rules.required] : []"
          :error-messages="$loja_gerenciar.cadastro.acesso.error.token_circus"
          :disabled="isDisabled"
        >
        </BaseTextField>
      </v-col>
      <v-col cols="12">
        <BaseTextField
          :label="$t('registrations.producers.default-event')"
          :placeholder="$t('registrations.producers.insert-default-event')"
          v-model="$loja_gerenciar.cadastro.acesso.idevento_default"
          type="text"
          @input="$loja_gerenciar.cadastro.acesso.error.idevento_default = []"
          :error-messages="
            $loja_gerenciar.cadastro.acesso.error.idevento_default
          "
          :disabled="isDisabled"
        >
        </BaseTextField>
      </v-col>
      <v-row class="px-3 pb-3">
        <v-col cols="12" class="pb-0">
          <v-btn
            class="button rounded-lg"
            width="100%"
            v-if="isEdit && fitToSync"
            @click="syncCircus"
            :loading="$loja_gerenciar.cadastro.acesso.loading_sync"
          >
            {{ $t("registrations.producers.sync") }}
            <v-icon class="ml-2"> mdi-sync </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            class="button rounded-lg"
            width="100%"
            v-if="isEdit && fitToSync"
            @click="syncCircusAll"
          >
            {{ $t("registrations.producers.sync-all") }}
            <v-icon class="ml-2"> mdi-sync </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
    <confirm-modal
      v-model="isConfirmationVisible"
      :title="$t('registrations.producers.confirmation')"
      :message="$t('registrations.producers.sync-confirmation-message')"
      :subtitle="$t('registrations.producers.sync-confirmation-subtitle')"
      @cancel="cancelConfirmation"
      @confirm="confirmAction"
      :loading="$loja_gerenciar.cadastro.acesso.loading_sync_all"
    />
  </CardModule>
</template>
<script>
import { mapGetters } from "vuex";
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import mixins from "../../mixins";
import ConfirmModal from "@/components/global/newConfirmDialog.vue";
const { formRules } = mixins;
export default {
  name: "lojas-gerenciar-acessos",
  mixins: [LojasGerenciarMixins, formRules],
  data() {
    return {
      isConfirmationVisible: false,
    };
  },
  components: {
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    ConfirmModal,
  },
  methods: {
    syncCircus() {
      this.$loja_gerenciar.syncCircus(this.$loja_gerenciar.sequenciador);
    },
    syncCircusAll() {
      this.showConfirmation();
    },
    showConfirmation() {
      this.isConfirmationVisible = true;
    },
    cancelConfirmation() {
      this.isConfirmationVisible = false;
    },
    async confirmAction() {
      await this.$loja_gerenciar.syncCircusAll(this.storeSequencial);
      this.isConfirmationVisible = false;
    },
  },
  computed: {
    ...mapGetters(["storeSequencial"]),
    isFill() {
      return (
        this.$loja_gerenciar.cadastro.acesso.url_circus !== "" ||
        this.$loja_gerenciar.cadastro.acesso.token_circus !== ""
      );
    },
    isEdit() {
      return this.$loja_gerenciar.lojaAddOrEdit == "edit";
    },
    fitToSync() {
      return this.$loja_gerenciar.cadastro.acesso.circus === 1;
    },
    isDisabled() {
      return this.$loja_gerenciar.cadastro.acesso.circus == 0 ? true : false;
    },
  },
  watch: {
    "$loja_gerenciar.cadastro.acesso.circus"() {
      if (!this.$loja_gerenciar.cadastro.acesso.circus) {
        this.$loja_gerenciar.cadastro.acesso.url_circus = "";
        this.$loja_gerenciar.cadastro.acesso.token_circus = "";
        this.$loja_gerenciar.cadastro.acesso.idevento_default = "";
      }
    },
  },
};
</script>
<style scoped></style>
